import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PageHistory = ({ history, separator = "›", color = "#333" }) => {
  const navigate = useNavigate();

  return (
    <Container fluid className="py-2">
      <div className="d-flex align-items-center flex-wrap" style={{ fontSize: "12px", color }}>
        {history.map((item, index) => (
          <span key={index} className="d-flex align-items-center">
            <span
              // onClick={() => index !== history.length - 1 && navigate(item.path)}
              style={{
                cursor: index === history.length - 1 ? "default" : "pointer",
                fontWeight: index === history.length - 1 ? "bold" : "normal",
              }}
            >
              {item.label}
            </span>
            {index !== history.length - 1 && (
              <span className="mx-1" style={{ fontSize: "14px" }}>{separator}</span>
            )}
          </span>
        ))}
      </div>
    </Container>
  );
};

export default PageHistory;
